module.exports = __webpack_public_path__ + "img/about_logo_18.f857da7c.png";